<template>
    <div class="modal fade rating_modal" :id="tabType" tabindex="-1" role="dialog" aria-labelledby="rating_modal">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h3 class="modal-title" id="rating_modal">Архивация</h3>
                </div>
                <!-- end /.modal-header -->

                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6 mt-2">
                            <p>Причина архивации</p>
                            <div class="right_content">
                                <div class="select-wrap" v-if="tabType === 'PROJECTS'">
                                    <select v-model="$v.archiveForm.reason.$model">
                                        <option value="funded">Проект профинансирован</option>
                                        <option value="cancelled">Проект отменен</option>
                                    </select>
                                    <span class="lnr lnr-chevron-down"></span>
                                </div>
                                <div class="select-wrap" v-else>
                                    <select v-model="$v.archiveForm.reason.$model">
                                        <option value="home_found">Пристроено</option>
                                        <option value="died">Погибло</option>
                                        <option value="adopted_by_volunteer">Оставил себе</option>
                                    </select>
                                    <span class="lnr lnr-chevron-down"></span>
                                </div>
                            </div>
                            <div class="field-error-text" v-if="$v.archiveForm.reason.$error">Необходимо выбрать причину</div>
                        </div>
                    </div>

                    <div class="rating_field mt-3 mb-3">
                        <label for="comment_field">Пожалуйста, расскажите о том что стало с питомцем. Все кто на него подписан получат эту историю.</label>
                        <textarea name="rating_field" v-model="$v.archiveForm.comment.$model" id="comment_field" class="text_field" placeholder="Расскажите, о ваших затратах"></textarea>
                        <div class="field-error-text" v-if="$v.archiveForm.comment.$error">Необходимо заполнить комментарий</div>
                    </div>

                    <!-- end /.form -->

                    <div class="form-group">
                        <div class="upload_wrapper mb-3">
                            <div class="row text-center">
                                <div class="col-12 col-md-6">
                                    <p>Прикрепите фотографии</p>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="custom_upload">
                                        <label :for="`screenshot-${tabType}`">
                                            <input type="file" :id="`screenshot-${tabType}`" name="photos" class="files w-100" accept=".png,.jpeg,.jpg,.gif" @change="addImages" multiple>
                                            <span class="btn btn--round btn--sm">Выберите фотографии</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-for="(image, index) in previewImages">
                            <div class="row mt-4">
                                <div class="col-3">
                                    <img :src="image.base64" alt="" class="w-100">
                                </div>
                                <div class="col-7" style="word-break: break-word;">
                                    {{ image.name }}
                                </div>
                                <div class="col-2 text-right">
                                    <span class="lnr upload_cross lnr-cross" style="cursor:pointer;" @click="deletePhoto(index)"></span>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="row">
                        <div class="col-md-12" v-if="archiveRequestStatus === 'failed'">
                            <button class="btn btn--round btn--danger w-100 success-result" data-dismiss="modal">Ошибка! Попробуйте позже.</button>
                        </div>
                        <div class="col-md-12" v-if="archiveRequestStatus === 'pending'">
                            <button class="btn btn--round btn--default w-100">Отправляется...</button>
                        </div>
                        <div class="col-md-12" v-if="archiveRequestStatus === 'success'">
                            <button class="btn btn--round btn--success w-100 success-result" data-dismiss="modal">Успешно</button>
                        </div>
                        <div class="col-md-6" v-if="archiveRequestStatus === 'waiting_to_send'">
                            <button class="btn btn--round btn--default w-100" @click="submitHistoryForm">Отправить</button>
                        </div>
                        <div class="col-md-6 mt-2 mt-md-0" v-if="archiveRequestStatus === 'waiting_to_send'">
                            <button class="btn btn--round btn--default w-100" data-dismiss="modal">Закрыть</button>
                        </div>
                    </div>


                </div>
                <!-- end /.modal-body -->
            </div>
        </div>
    </div>
</template>

<script>
import {required, reset} from "vuelidate/lib/validators";
export default {
    name: "TabPetModal",
    props: ['setArchiveProps', 'tabType'],
    data (){
        return{
            archiveRequestStatus: 'waiting_to_send',
            noReloadPreview: false,
            previewImagesOnlyBase64: [],
            previewImages: [],
            images: [],
            archiveForm: {
                objectId: null,
                type: null,
                comment: null,
                images: [],
                reason: null,
            },
        }
    },
    mounted(){
        let self = this;

        $('.modal').on('hidden.bs.modal', function (e){

            self.archiveForm = {
                    objectId: null,
                    type: null,
                    comment: null,
                    images: [],
                    reason: null,
            }

            self.$v.$reset()
        })

    },

    methods:{

        submitHistoryForm() {
            let self = this;
            let endpoint;

            self.$v.$touch();
            if (self.$v.$invalid) {
                return false;
            }
            self.archiveRequestStatus = 'pending';


            let data = new FormData();
            data.append('comment', self.archiveForm.comment);
            data.append('reason', self.archiveForm.reason);

            self.previewImagesOnlyBase64.forEach(function (base64) {
                let block = base64.split(";");
                let contentType = block[0].split(":")[1];
                let realData = block[1].split(",")[1];
                let blob = self.b64toBlob(realData, contentType);
                data.append('images[]', blob)
            });

            if (self.archiveForm.type === 'pet') {
                endpoint = '/pets/' + self.archiveForm.objectId + '/archive';
            } else if (self.archiveForm.type === 'project') {
                endpoint = '/projects/' + self.archiveForm.objectId + '/archive'
            }

            axios.post(endpoint, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        self.archiveRequestStatus = 'success';
                        this.$emit('archiveHook', this.tabType)
                    } else {
                        self.archiveRequestStatus = 'failed';

                        setTimeout(function () {
                            self.archiveRequestStatus = 'waiting_to_send';
                        }, 3000);
                    }
                })
                .catch((error) => {

                })
                .then();
        },
        deletePhoto(index) {
            let self = this;
            self.noReloadPreview = true;
            self.previewImages.splice(index, 1);
            self.images.splice(index, 1);
            self.archiveForm.images.splice(index, 1);
            self.previewImagesOnlyBase64.splice(index, 1);
        },
        addImages(e) {
            let self = this;
            let files = e.target.files;
            self.images = [];

            for (let key in files) {


                if (e.target.files[key] instanceof File) {
                    self.images.push(e.target.files[key]);
                }
            }
        },
        b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            let byteCharacters = atob(b64Data);
            let byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                let byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, {type: contentType});
        },
    },


    watch: {
        images() {
            let self = this;

            if (self.noReloadPreview) {
                self.noReloadPreview = false;
                return false
            }

            self.images.forEach(function (image) {
                if (typeof FileReader === "function") {
                    const reader = new FileReader();

                    reader.onload = event => {
                        if ($.inArray(event.target.result, self.previewImagesOnlyBase64) === -1) {
                            self.previewImages.push({
                                'base64': event.target.result,
                                'name': image.name,
                            });
                            self.previewImagesOnlyBase64.push(event.target.result);
                            self.archiveForm.images.push(image);
                        }
                    };

                    reader.readAsDataURL(image);
                }
            });
        },
        setArchiveProps(){
            this.archiveForm.objectId = this.setArchiveProps.id;
            this.archiveForm.type = this.setArchiveProps.type ? 'pet' : 'project';
            this.archiveRequestStatus = 'waiting_to_send';
        }
    },
    validations: {
        archiveForm: {
            reason: {
                required
            },
            comment: {
                required
            },
            objectId: {
                required
            },

        },
    }

}
</script>

<style lang="scss" scoped>


.modal .modal-title {
    margin-bottom: 0;
}

.modal .modal-header {
    padding: 10px 30px;
}

.modal .modal-body {
    padding: 10px 30px 30px 30px;
}

.rating_modal .modal-body .text_field {
    margin-bottom: 0;
}

.success-result {
    line-height: 50px;
    min-width: 170px;
}

@media screen and ('max-width: 768px'){
    .rating_field label{
        font-size: 12px;
        line-height: 14px;
    }
}

</style>
